module.exports = __webpack_public_path__ + "img/DCC.6be9185d.svg";